// ============================================================
// regroupementEcran — ce que l'écran DIT d'une pièce sur plusieurs
// feuilles (4 novembre 2026).
// ------------------------------------------------------------
// Une pièce regroupée montre ses feuilles et POURQUOI elles sont ensemble ;
// une proposition montre ce qui est identique et ce qui diffère. Le
// deviseur ne doit jamais avoir à deviner ce que le programme a fait.
// L'état vient du serveur (`GET /devis/:id/regroupements`), chargé par
// `useRegroupements.js`. Ce fichier-ci est pur : aucune dépendance.
// ============================================================

/** « 24550 — feuilles 1, 2, 3 », ou `null` pour une pièce d'une seule feuille. */
export function libelleFeuilles(info, ref = null) {
  const feuilles = info?.feuilles ?? [];
  if (feuilles.length < 2) return null;
  const num = (f) => f.planche?.x ?? f.page_number ?? '?';
  const docs = new Set(feuilles.map((f) => f.document));
  const liste = docs.size > 1
    ? feuilles.map((f) => `${f.document ?? '?'} p. ${f.page_number ?? '?'}`).join(', ')
    : `feuilles ${feuilles.map(num).join(', ')}`;
  return ref ? `${ref} — ${liste}` : liste;
}

/** Pourquoi ces feuilles sont ensemble : automatique (et sur quoi), ou à la main. */
export function libelleMotif(regroupement) {
  if (!regroupement) return null;
  if (regroupement.mode === 'auto') return `Regroupées automatiquement : ${regroupement.raison}.`;
  return `${regroupement.raison ? regroupement.raison[0].toUpperCase() + regroupement.raison.slice(1) : 'Regroupées à la main'}.`;
}

/** Ce qui diffère entre les pièces d'une proposition, en une phrase. */
export function libelleEcarts(ecarts = []) {
  if (!ecarts.length) return null;
  return ecarts.map((e) => (e.critere === 'document'
    ? 'elles viennent de documents distincts'
    : `${e.critere} : « ${e.a ?? 'absente'} » / « ${e.b ?? 'absente'} »`)).join(' · ');
}

/** Les pages à montrer pour une pièce : toutes ses feuilles, sinon sa page. */
export function pagesDeLaPiece(piece, etat) {
  if (!piece?.plan_file_id) return [];
  const info = etat?.pieces?.[piece.id];
  if (info?.feuilles?.length > 1) return info.feuilles.map((f) => ({ id: f.file_id, page_number: f.page_number }));
  return [{ id: piece.plan_file_id, page_number: piece.plan_index ?? null }];
}
